module.exports = __webpack_public_path__ + "officialStatic/img/bydLogo.7af690b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/bydLogo.png
// module id = uVg4
// module chunks = 0